import { TLanguage } from '@simOn/common/language';
import { EnergyUnitEnum, PowerUnitEnum, PreferencesUnitsInterface, TemperatureUnitEnum } from '@simOn/common/units';

export interface UserProfileInterface {
  profileExists: boolean;
  eulaAccepted: boolean;
}

export interface CreateUserProfileInterface {
  userName: string;
  email: string;
  eulaVersion: string;
}

export const PROJECT_INITIAL_VIEW = {
  Unknown: 'Unknown',
  Dashboard: 'Dashboard',
  ThreeDView: 'ThreeDView'
} as const;

export type ProjectInitialViewType = keyof typeof PROJECT_INITIAL_VIEW;

export interface UserPreferencesInterface {
  showUnauthorizedUserModal: boolean;
  autoReportErrors: boolean;
  units: PreferencesUnitsInterface;
  priceForOneEnergyUnit: number;
  priceCurrency: string;
  showPowerAsPrice: boolean;
  openAttachmentInNewTab: boolean;
  languageMode: TLanguage;
  projectInitialView: ProjectInitialViewType;
}

export interface UserApartmentPreferencesInterface {
  preferences: UserPreferencesInterface;
}

export enum TemperatureUnitSymbolEnum {
  Celsius = '\xB0C',
  Fahrenheit = '\xB0F',
  Kelvin = 'K'
}

export enum PowerUnitSymbolEnum {
  Watt = 'W'
}

export enum EnergyUnitSymbolEnum {
  kWh = 'kWh',
  Joule = 'J'
}

export const TEMPERATURE_UNIT_LABEL: Record<keyof typeof TemperatureUnitEnum, string> = {
  Unknown: $localize`:@@GENERAL_UNKNOWN:Unknown`,
  Celsius: $localize`:@@GENERAL_CELSIUS:Celsius`,
  Fahrenheit: $localize`:@@GENERAL_FAHRENHEIT:Fahrenheit`,
  Kelvin: $localize`:@@GENERAL_KELVIN:Kelvin`
};

export const ENERGY_UNIT_LABEL: Record<keyof typeof EnergyUnitEnum, string> = {
  Unknown: $localize`:@@GENERAL_UNKNOWN:Unknown`,
  kWh: $localize`:@@GENERAL_KWH:kWh`,
  Joule: $localize`:@@GENERAL_JOULE:Joule`
};

export const POWER_UNIT_LABEL: Record<keyof typeof PowerUnitEnum, string> = {
  Unknown: $localize`:@@GENERAL_UNKNOWN:Unknown`,
  Watt: $localize`:@@GENERAL_WATT:Watt`
};
